// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-22-2024
// ***********************************************************************
// <copyright file="_tooltip.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing and managing Bootstrap tooltips 
//     in a Blazor application, enabling rich user interactions with tooltip components.
// </summary>
// ***********************************************************************

window.user_profile = window.user_profile || {};

/**
 * Applies the saved user font size on load.
 *
 * @function applySavedFontSize
 * @memberof window.actions
 */
window.user_profile.applySavedFontSize = function () {
    localStorage.removeItem('userFontScale');
    const zoom = localStorage.getItem('userFontZoom');
    if (zoom) {
        document.documentElement.style.setProperty('--user-font-zoom', zoom);
    }
};

/**
 * Scales the type relative to the theme's base size and remembers the factor.
 *
 * @function setUserFontZoom
 * @memberof window.user_profile
 * @param {string} factor - A multiplier such as '0.9', '1' or '1.3'.
 */
window.user_profile.setUserFontZoom = function (factor) {
    document.documentElement.style.setProperty('--user-font-zoom', factor);
    localStorage.setItem('userFontZoom', factor);
};

/**
 * Returns the saved zoom factor, or null when the default applies.
 *
 * @function getUserFontZoom
 * @memberof window.user_profile
 * @returns {string|null} The saved factor, such as '1.1'.
 */
window.user_profile.getUserFontZoom = function () {
    return localStorage.getItem('userFontZoom');
};
